const rankingData = [
  { rank: 1, title: '长安三万里', score: '9.4', tag: '动画史诗', desc: '追光动画十年力作，以盛唐为背景展现李白与高适的传奇人生' },
  { rank: 2, title: '流浪地球2', score: '9.2', tag: '科幻巨制', desc: '人类面临太阳危机，团结一致开启带着地球去流浪的壮丽旅程' },
  { rank: 3, title: '满江红', score: '9.0', tag: '历史悬疑', desc: '南宋绍兴年间，岳飞死后四年，一场围绕秦桧的惊天阴谋徐徐展开' },
  { rank: 4, title: '孤注一掷', score: '8.8', tag: '反诈题材', desc: '揭秘境外网络诈骗全产业链内幕，程序员与模特深陷诈骗工厂' },
  { rank: 5, title: '封神第一部', score: '8.7', tag: '神话史诗', desc: '殷商末年，狐妖现世，纣王无道，一场人仙妖三界大战即将爆发' },
  { rank: 6, title: '八角笼中', score: '8.6', tag: '现实题材', desc: '向腾辉倾注心血培养山区孤儿格斗，却被舆论推向风口浪尖' },
  { rank: 7, title: '消失的她', score: '8.5', tag: '悬疑剧情', desc: '丈夫报案妻子海外失踪，神秘女子却自称是他妻子，真相扑朔迷离' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            实时更新热门国产影视排行，看看大家都在追什么好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {rankingData.map((item) => (
            <div
              key={item.rank}
              className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group"
            >
              <div className={`shrink-0 w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg font-heading text-lg font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                    《{item.title}》
                  </h3>
                  <span className="shrink-0 text-xs font-medium text-accent-600 bg-accent-100/60 px-1.5 py-0.5 rounded">
                    {item.score}分
                  </span>
                </div>
                <span className="inline-block text-xs text-primary-600 bg-primary-50 px-1.5 py-0.5 rounded mb-1 whitespace-nowrap">
                  {item.tag}
                </span>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}